import {GopayOutletData} from 'pages'
import {QrisOutletData} from 'types'

export const PAYMENT_CURRENCY_NAME_DEFAULT = 'IDR'

export const PAYMENT_CURRENCY_ID_DEFAULT = 'MR9Xdjv70WpeODE8DEPLAyb8xVBQzq31'

export const INITIALIZE_GOPAY_DATA: GopayOutletData = {
  actions: {
    cancel: '',
    deeplink_redirect: '',
    qr_checkout_string: '',
    generate_qr_code: '',
  },
  id: '',
  name: '',
  payment_type: '',
  transaction_time: '',
}

export const INITIALIZE_QRIS_DATA: QrisOutletData = {
  actions: {
    qr_string: '',
  },
  id: '',
  transaction_time: '',
  expiration_date: '',
}
